var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteAllowanceDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.801,
    height: 108.801,
    viewBox: "0 0 108.801 108.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "building",
    d: "M18.134,58.934h13.6V68h-13.6ZM40.8,68H54.4V58.934H40.8ZM18.134,86.134h13.6V77.068h-13.6Zm22.667,0H54.4V77.068H40.8Zm-22.667-54.4h13.6V22.667h-13.6Zm22.667,0H54.4V22.667H40.8ZM18.134,49.867h13.6V40.8h-13.6Zm22.667,0H54.4V40.8H40.8Zm68-13.6V108.8H0V13.6A13.6,13.6,0,0,1,13.6,0H58.934a13.6,13.6,0,0,1,13.6,13.6v9.067H95.2A13.6,13.6,0,0,1,108.8,36.267ZM63.467,13.6a4.533,4.533,0,0,0-4.533-4.533H13.6A4.533,4.533,0,0,0,9.067,13.6V99.734h54.4ZM99.734,36.267A4.533,4.533,0,0,0,95.2,31.734H72.534v68h27.2ZM81.6,68h9.067V58.934H81.6Zm0,18.134h9.067V77.068H81.6Zm0-36.267h9.067V40.8H81.6Z",
    fill: "#efefef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteAllowanceDefault);
export default __webpack_public_path__ + "static/media/SiteAllowanceDefault.e46088a263c0284426e15790f0c2383b.svg";
export { ForwardRef as ReactComponent };